class ClientConfiguration {
    public ReportingSisenseSharedSecret: string;
    public ReportingSisenseUser: string;
    public ReportingMyleUser: string;
    public ReportingSisenseMainURL: string;
    public ReportingSisenseDashboardURL: string;
    public ReportingSisenseExpirationSeconds: number;
    public HasMedfarRAMQ: boolean;
    public ClientTag: string;
    public PatientEditRelationshipDisabled: boolean;
    public HandwrittenNoteBackgroundPath: string;
    public MaxConcurrentSessions: number;
    public InactiveSessionBlacklistEnabled: boolean;
    public ChartServicePrintURL: string;
    public FrontpageCampaignUrl: string;
    public MinPasswordLengthAdminUser: number;
    public MinPasswordLengthRegularUser: number;
    public PasswordValidationRegexRegularUser: string;
    public PasswordValidationRegexAdminUser: string;
}

export { ClientConfiguration };
